import { Component, OnChanges, OnDestroy, input } from '@angular/core';

import { AnchorDirective, CurrencyPipe, DynamicHtmlDirective } from '@frontend/vanilla/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { Config, LIMIT_PERIOD } from '../../../../config/appConstants';
import { DepositInfo } from '../../../../model/depositInfo.model';
import { MessageType } from '../../../../model/message.model';
import { QDInstrument, TxnLimitInfo } from '../../../../model/qdInstrument.model';
import { BehaviorDataService } from '../../../../service/behaviorData.service';
import { DepositService } from '../../../../service/deposit.service';
import { UserDataService } from '../../../../service/userDataService';
import { MessageComponent } from '../messages/message-component';

@Component({
    selector: 'app-deposit-limit-message',
    templateUrl: 'deposit-limit-message.component.html',
    imports: [MessageComponent, TranslateModule, CurrencyPipe, AnchorDirective, DynamicHtmlDirective],
})
export class DepositLimitMessageComponent implements OnChanges, OnDestroy {
    readonly selectedOption = input.required<QDInstrument>();
    depositInfo: DepositInfo;
    selfLimits: TxnLimitInfo;

    maxDepositLimit: any;
    ccDepositLimitCheckEnabled: boolean;
    showCCDepositLimitCheckMsg: boolean;
    ccCurrentDepositLimit: number;
    limitPeriod: string;
    country: string;
    maxLimit: number;
    $subscriptions: Subscription[] = [];
    minDepositLimitCheck: boolean;
    ccDepositUcapLimit: any;
    instrumentName: any;
    currencyUSD: string = 'USD';
    messageType = MessageType;

    constructor(
        private behaviorData: BehaviorDataService,
        private depositService: DepositService,
        private translate: TranslateService,
        private userDataService: UserDataService,
    ) {
        this.depositInfo = this.depositService?.depositInfo;
        const configParams = this.userDataService?.userData?.configParams;
        this.ccDepositLimitCheckEnabled = configParams?.isCreditCardDepositLimitCheckEnabled === Config.YES;
        if (this.ccDepositLimitCheckEnabled) {
            this.ccDepositUcapLimit = configParams?.creditCardDepositUppercapLimit;
            this.ccCurrentDepositLimit = +configParams?.currentCreditCardDepositLimit;
        }
        this.country = this.userDataService?.userData?.userInfo?.addressInfo?.country;
    }

    ngOnChanges() {
        this.initialize();
    }

    initialize() {
        if (this.selectedOption()?.paymentMethodInfo) {
            this.selfLimits = this.selectedOption().paymentMethodInfo?.txnLimitInfo;
            this.maxLimit = this.selectedOption().paymentMethodInfo?.maxDepositLimit?.value;
            this.limitPeriod = this.selfLimits?.type?.substring(this.selfLimits?.type.lastIndexOf('_') + 1);

            const maxLimit = this.selectedOption().paymentMethodInfo?.txnLimitInfo?.maxLimit?.value;
            this.maxDepositLimit = maxLimit ? parseFloat(maxLimit).toFixed(2) : '0';
            if (LIMIT_PERIOD.includes(this.limitPeriod) && this.selfLimits?.type?.includes('purchase_limit')) {
                this.limitPeriod = this.translate.instant('PARTY.CASHIER.web.deposit.purchase.limit.' + this.limitPeriod);
                this.maxDepositLimit = Number(this.maxDepositLimit);
            }
            this.minDepositLimitCheck =
                parseFloat(this.maxDepositLimit) > this.selectedOption().paymentMethodInfo?.minDepositLimit?.value ? true : false;
            if (this.depositInfo?.isBelgiumRgDecreeEnabled) {
                this.maxLimit = parseFloat(this.selectedOption().paymentMethodInfo?.txnLimitInfo?.maxLimit?.value);
            }
            const paymentMethod = this.selectedOption().paymentMethodInfo?.paymentMethod;
            this.instrumentName = paymentMethod[0]?.toUpperCase() + paymentMethod?.toLowerCase().slice(1, paymentMethod?.length);
        }

        this.$subscriptions.push(
            this.behaviorData.getCCDepositLimitCheckMsg.subscribe((data) => {
                this.showCCDepositLimitCheckMsg = data;
            }),
        );
    }

    changeAmount(): void {
        this.behaviorData.changeEnteredAmount(this.maxDepositLimit.toFixed(2));
    }

    updateCcdLimit(): void {
        this.behaviorData.changeEnteredAmount(`${this.ccCurrentDepositLimit}`);
    }

    ngOnDestroy(): void {
        this.$subscriptions.map((subscription) => subscription.unsubscribe());
    }
}
